module.exports = "<i class=\"material-icons {{$ctrl.colorClass}} s16\">{{$ctrl.icon}}</i> ";